"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Calendar } from "lucide-react";
function BlogPostsConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground mb-4">Failed to load blog posts.</p>
        <button onClick={refetch} className="text-accent hover:text-accent-hover underline">
          Retry
        </button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No blog posts to display.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden border border-border hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
          {post.featuredImage && <div className="aspect-[16/10] w-full overflow-hidden">
              <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-slow)] group-hover:scale-105" />
            </div>}
          <CardHeader className="px-6 pt-6">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
              <SafeHydrate><Calendar className="h-4 w-4" /></SafeHydrate>
              {post.date && <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
                </time>}
            </div>
            <CardTitle className="text-xl font-display font-semibold text-foreground leading-tight group-hover:text-accent transition-colors duration-[var(--duration-fast)]">
              {post.title}
            </CardTitle>
          </CardHeader>
          {post.excerpt && <CardContent className="px-6">
              <CardDescription className="text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />
            </CardContent>}
          {post.link && <CardContent className="px-6 pb-6">
              <Link to={post.link} className="inline-flex items-center text-accent hover:text-accent-hover font-semibold transition-colors duration-[var(--duration-fast)]">
                Read more →
              </Link>
            </CardContent>}
        </Card>)}
    </div>;
}
export default function BlogPosts() {
  return <section id="blog-posts" className="!bg-[hsl(0,0%,100%)] ![padding:96px_0px_128px_0px]">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-12">
          <p className="text-accent text-sm font-sans font-semibold tracking-wider uppercase mb-3">
            LATEST INSIGHTS
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground">Read Our Latest News</h2>
        </div>
        
        <PostsProvider className="blog-posts-wrapper" postType="post" wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date",
        status: ["publish"]
      }} embeds={["wp:featuredmedia", "author"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "date", "_embedded", "_links.wp:featuredmedia", "_links.author"]}>
          <BlogPostsConsumer />
        </PostsProvider>
      </div>
    </section>;
}